import css from 'styled-jsx/css';
import { screen } from 'components/styles/variables';

const bodyTypesSearchesStyles = css`
  .body-type {
    padding: 0 15px;
  }

  @media (min-width: ${screen.smMin}) {
    .body-type {
      width: 750px;
      margin-right: auto;
      margin-left: auto;
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .body-type {
      width: 970px;
    }
  }

  @media (min-width: ${screen.lgMin}) {
    .body-type {
      width: 1170px;
    }
  }

  .body-styles-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .body-styles-container {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`;
export default bodyTypesSearchesStyles;
